import styled from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const WalletTabs = styled.nav`
  display: flex;
  flex-wrap: nowrap;
  gap: 1.75rem;
  margin: 0 0 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.grey};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const WalletTab = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  position: relative;
  padding: 0.75rem 0;
  border: none;
  background: transparent;
  color: ${({ theme, $active }) => ($active ? theme.dark : theme.midGrey)};
  font-size: 1rem;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    border-radius: 2px 2px 0 0;
    background: ${({ theme, $active }) => ($active ? theme.dark : 'transparent')};
  }

  &:hover {
    color: ${({ theme }) => theme.dark};
  }
`;

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
`;

export const SearchControl = styled.div`
  width: 16rem;
  max-width: 100%;
  flex: 0 1 16rem;
`;

export const DueBadge = styled.span<{ $due?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.65rem;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme, $due }) => ($due ? '#c0392b' : theme.dark)};
  background: ${({ theme, $due }) => ($due ? 'rgba(192, 57, 43, 0.12)' : theme.primary90)};
`;

export const ActionsRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const RescreenButton = styled.button`
  height: 2.25rem;
  padding: 0 0.85rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.dark};
  font-size: 0.8125rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem 1.5rem;

  ${media.md} {
    grid-template-columns: 1fr;
  }
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
`;

export const DetailLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  color: ${({ theme }) => theme.midGrey};
  text-transform: capitalize;
`;

export const DetailValue = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.dark};
  word-break: break-word;
`;

export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.midGrey};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const UserLink = styled.button<{ $muted?: boolean }>`
  border: none;
  background: transparent;
  padding: 0;
  color: ${({ theme, $muted }) => ($muted ? theme.midGrey : theme.primary)};
  font: inherit;
  font-weight: ${({ $muted }) => ($muted ? 400 : 600)};
  cursor: ${({ $muted }) => ($muted ? 'default' : 'pointer')};
  text-align: left;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: ${({ $muted }) => ($muted ? 'none' : 'underline')};
  }
`;
